import { getWinstonUsersMe } from '../../../clients/winston/generated/sdk.gen'

import type { User } from './types'

export async function getUser(): Promise<User> {
  const { data, error } = await getWinstonUsersMe()

  if (error || !data) {
    throw new Error('Failed to fetch user data')
  }

  return {
    organisationId: data.data.user.organisation_id,
    permissions: data.data.user.permissions,
    planId: data.data.user.plan_id,
    planName: data.data.user.plan_name,
    userId: data.data.user.user_id,
  }
}
